import axios from 'axios';
import download from 'downloadjs';

import Constants from './Constants';

const PrintService = () => {
  const PRINT_URL = Constants.PRINT.URL;
  const _headers = (accessToken) => ({
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  const generatePdf = (accessToken, data, template, orientation, contents) =>
    axios.post(
      `${PRINT_URL}/generatePdf`,
      { template, contents, orientation, data },
      { responseType: 'arraybuffer', ..._headers(accessToken) }
    );

  const generateFlashReportPdf = (
    accessToken,
    data,
    template,
    orientation,
    contents
  ) =>
    axios.post(
      `${PRINT_URL}/generateFlashReport`,
      { template, contents, orientation, data },
      { responseType: 'arraybuffer', ..._headers(accessToken) }
    );

  const printHtmlPdf = (
    accessToken,
    data,
    fileName,
    template,
    orientation,
    contentHTML
  ) => {
    return generatePdf(
      accessToken,
      data,
      template,
      orientation,
      contentHTML
    ).then(
      ({ data: file }) => {
        download(file, fileName);
      }
    );
  };

  const printFlashReportPdf = (
    accessToken,
    data,
    fileName,
    template,
    orientation,
    contentHTML
  ) => {
    return generateFlashReportPdf(
      accessToken,
      data,
      template,
      orientation,
      contentHTML
    ).then(({ data: file }) => {
      download(file, fileName);
    });
  };

  return {
    printHtmlPdf,
    printFlashReportPdf,
  };
};

export default PrintService;
